<template>
  <section class="cn-rich-footer">
    <div class="cn-rich-footer__block">
      <div class="container">
        <div class="cn-rich-footer__content">
          <div class="cn-rich-footer__text">
            <ul v-if="data.items?.length" class="cn-rich-footer__list">
              <li
                v-for="(item, i) in data.items"
                :key="i"
                class="cn-rich-footer__list-item"
              >
                <span class="cn-rich-footer__list-item-icon">
                  <CdnImg
                    v-if="item.image"
                    :src="item.image.path"
                    loading="lazy"
                    :width="20"
                    :height="20"
                  />
                  <UiIcon v-else name="check" />
                </span>
                <span class="cn-rich-footer__list-item-text">
                  {{ item.text }}
                </span>
              </li>
            </ul>
          </div>
          <div class="cn-rich-footer__image">
            <CdnImg
              v-if="data.image"
              :src="data.image.path"
              format="webp"
              loading="lazy"
              :width="534"
              :height="532"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { CdnImg } from '@webplatform/cdn-image';
import UiIcon from '@/components/ui/UiIcon';

interface Props {
  data: {
    items?: {
      text?: string;
      image?: {
        path: string;
      };
    }[];
    image?: {
      path: string;
    };
  };
}
defineProps<Props>();
</script>
<style lang="scss">
.cn-rich-footer {
  --ab-canyon-rich-footer-block-color-bg: var(--ab-canyon-color-primary);
  --ab-canyon-rich-footer-list-item-icon-color-bg: var(
    --ab-canyon-color-accent
  );
  --ab-canyon-rich-footer-list-item-icon-color-text: var(
    --ab-canyon-color-light
  );
  --ab-canyon-rich-footer-list-item-text-color-text: var(
    --ab-canyon-color-neutral-light
  );

  padding-top: calc(8 * var(--size-base));

  @media (min-width: 992px) {
    padding-top: var(--size-4xl);
    padding-bottom: var(--size-4xl);
  }
  @media (min-width: 1280px) {
    padding-top: calc(8 * var(--size-base));
    padding-bottom: calc(8 * var(--size-base));
  }

  &__block {
    background-color: var(--ab-canyon-rich-footer-block-color-bg);
    padding-top: 60px;
    padding-bottom: 60px;
  }
  &__content {
    row-gap: var(--size-5xl);
    column-gap: var(--size-xl);
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    max-width: 1280px;
    display: flex;
    margin-left: auto;
    margin-right: auto;
    @media (min-width: 992px) {
      flex-wrap: nowrap;
    }
  }
  &__text {
    width: 100%;
    @media (min-width: 992px) {
      width: 41.666667%;
    }
  }
  &__list {
    > :not([hidden]) {
      ~ :not([hidden]) {
        margin-top: var(--size-3xl);
      }
    }
  }
  &__list-item {
    column-gap: var(--size-base);
    align-items: center;
    display: flex;
  }
  &__list-item-icon {
    background-color: var(--ab-canyon-rich-footer-list-item-icon-color-bg);
    color: var(--ab-canyon-rich-footer-list-item-icon-color-text);
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    display: flex;
    .cn-icon {
      width: var(--size-lg);
      height: var(--size-lg);
    }
  }
  &__list-item-text {
    color: var(--ab-canyon-rich-footer-list-item-text-color-text);
  }
  &__image {
    max-width: calc(32 * var(--size-base));
    width: 100%;
    order: -9999;
    @media (min-width: 992px) {
      max-width: none;
      width: 58.333333%;
      order: 0;
    }
    img {
      margin-left: auto;
      margin-top: -150px;
      @media (min-width: 992px) {
        margin-top: -45%;
        margin-bottom: -35%;
      }
    }
  }
}
</style>
